//states/login.js
import { make } from "vuex-pathify"

const state = {
  tableCache: []
};

const mutations = make.mutations(state);


export default {
  namespaced: true,
  state,
  mutations
}